import { HttpClient } from '@angular/common/http';

import { Injectable } from '@angular/core';

import { ConfigProvider } from '../../providers/config/config';

@Injectable()
export class LocationProvider {
	constructor(
		private http: HttpClient
	) {
		console.log('Istanziato nuovo LocationProvider');
	}

	public search(prefix: String) {
		return this.http.get(ConfigProvider.HOST + "/location?types=city|province&prefix=" + prefix);
	}
}



// WEBPACK FOOTER //
// ./src/providers/location/location.ts